<template>
  <div class="table-tools-pagination grid grid-cols-2 w-full xl:w-auto select-none">
    <div class="flex items-center w-full xl:w-auto space-x-2 pr-2">
        <div class="flex flex-none items-center space-x-2 text-sm">
            <span class="hidden sm:flex dark:text-darkblue-200">{{ $t('app.page') }}</span>
            <base-input v-model="auxCurrentPage" @change="changeCurrentPage" type="text" name="currentPage" size="xs" align="center" custom="w-16" />
            <span class="dark:text-darkblue-200">{{ $t('app.of_pages', { totalPages: $n(totalPages, 'integer') }) }}</span>
        </div>
        <div class="flex items-center ml-2 space-x-2">
            <base-button-icon @click="prevPageHandler" name="chevronleft" size="xs" mode="primary-phantom" />
            <base-button-icon @click="nextPageHandler" name="chevronright" size="xs" mode="primary-phantom" />
        </div>
    </div>
    <div class="flex items-center w-full lg:w-auto space-x-2 pl-2 justify-end lg:justify-start">
      <base-select v-model="localPerPage" :data="pages" @change="changePerPage" name="itemsperpage" size="tiny" />
      <span class="hidden sm:flex flex-col text-xs text-secondary-500 dark:text-darkblue-200">
        <span>{{ $t('app.per_page') }}</span>
        <span class="font-bold">{{ $n(from, 'integer') }} - {{ $n(to, 'integer') }} {{ $t('app.of') }} {{ $n(total, 'integer') }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGES } from '@/config/app'

export default {
  name: 'base-table-pagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: DEFAULT_PAGE_SIZE
    },
    pages: {
      type: Array,
      default: () => DEFAULT_PAGES
    }
  },
  data: function () {
    return {
      localCurrentPage: this.currentPage,
      auxCurrentPage: this.currentPage,
      localPerPage: this.perPage
    }
  },
  computed: {
    totalPages: function () {
      if (this.total === 0 || this.localPerPage === 0) return 1
      return Math.ceil(this.total / this.localPerPage)
    },
    from: function () {
      return ((this.localPerPage * this.localCurrentPage) - this.localPerPage) + 1
    },
    to () {
      let max = this.localPerPage * this.localCurrentPage
      if (max > this.total) {
        max = this.total
      }
      return max
    }
  },
  methods: {
    paginationInfoChangeHandler (data) {
      this.inputPage = data.currentPage
      this.localCurrentPage = data.currentPage
    },
    changeCurrentPage: function () {
      let value = parseInt(this.auxCurrentPage)
      if (isNaN(value) || value < 1) {
        value = 1
      } else if (value > this.totalPages) {
        value = this.totalPages
      }
      this.auxCurrentPage = value
      this.localCurrentPage = value
      this.$emit('changeCurrentPage', value)
    },
    nextPageHandler: function () {
      if (this.localCurrentPage !== this.totalPages) {
        this.localCurrentPage++
        this.$emit('changeCurrentPage', this.localCurrentPage)
      }
    },
    prevPageHandler: function () {
      if (this.localCurrentPage !== 1) {
        this.localCurrentPage--
        this.$emit('changeCurrentPage', this.localCurrentPage)
      }
    },
    changePerPage: function (event) {
      this.$emit('changePerPage', event)
    }
  },
  watch: {
    currentPage: function () {
      this.auxCurrentPage = this.currentPage
      this.localCurrentPage = this.currentPage
    },
    perPage: function () {
      this.localPerPage = this.perPage
    }
  }
}
</script>

<style lang="scss" scoped></style>
